"use client";

import { useEffect, useState } from "react";
import Pagination from "../shared/paginator/paginator.js";
import EmptyState from "../shared/EmptyState.js";
import FilterNoResults from "../shared/FilterNoResults.js";
import { getLeadershipPotentialAccess } from "../shared/access.js";
import {
  Users,
  Star,
  TrendingUp,
  Award,
  Target,
  Brain,
  MessageSquare,
  ChevronDown,
  ChevronUp,
  ExternalLink,
  Search,
  Filter,
  Info,
  User,
  X,
} from "lucide-react";
import NoDataFound from "../shared/NoDataFound.js";
// import Multiselect from "multiselect-react-dropdown";

import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Modal from "../layout/Modal";
import BackButton from "../shared/backButton";
import CustomReadinessFilter from "../shared/CustomReadinessFilter";
import CustomTooltip from "../shared/CustomTooltip";
import "./LeadershipPage.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { handleApiError as baseHandleApiError } from "../shared/util";
import SubscriptionExpiredModal from "../dashboard/SubscriptionExpiredModal";
import { useTranslation } from "react-i18next";

import {
  getLeadershipPotentialsApi,
  createLeadershipNominationApi,
} from "../../services/upskillingService";
const LeadershipPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchInputValue, setSearchInputValue] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const paramUserIds = searchParams.getAll("userId");
  const [filterTeam, setFilterTeam] = useState("All");
  const [filterSeniority, setFilterSeniority] = useState("All");
  // already in your file:
  const leadershipAccess = getLeadershipPotentialAccess();
  // NEW: read readiness from URL
  const readinessFromUrl = searchParams.getAll("readiness");
  const countHome = Number(searchParams.get("count") || 0);
  const hasCountInUrl = searchParams.has("count");

  const removeCountFromUrl = () => {
    if (!searchParams.has("count")) return;

    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete("count");
    setSearchParams(nextParams, { replace: true });
  };
  const normalizeList = (arr) => {
    const cleaned = Array.from(
      new Set((arr || []).map((x) => (x || "").trim()).filter(Boolean)),
    );
    const hasReal = cleaned.some((x) => x !== "All");
    return hasReal ? cleaned.filter((x) => x !== "All") : [];
  };

  const getInitialReadiness = () => {
    // 1) if readiness is provided in URL, use it
    if (readinessFromUrl.length) return normalizeList(readinessFromUrl);

    // 2) keep your old behavior for userId deep links (optional)
    if (paramUserIds.length) return ["Promotion-ready", "Leadership-ready"];

    // 3) default = All (empty array means no filter in your code)
    return [];
  };

  const getNominationsNavigationPath = () => {
    const readinessFilters = normalizeList(filterReadiness);

    if (!readinessFilters.length) {
      return "/talent-development/nominations";
    }

    const nextParams = new URLSearchParams();
    readinessFilters.forEach((readiness) =>
      nextParams.append("readiness", readiness),
    );

    return `/talent-development/nominations?${nextParams.toString()}`;
  };

  const [filterReadiness, setFilterReadiness] = useState(getInitialReadiness);

  // keep state in sync if only query params change
  useEffect(() => {
    setFilterReadiness(getInitialReadiness());
    setCurrentPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams.toString()]);
  // const [filterReadiness, setFilterReadiness] = useState(
  //   paramUserIds.length === 0
  //     ? [] // All
  //     : ["Promotion-ready", "Leadership-ready"],
  // );
  const [sortBy, setSortBy] = useState("Leadership Score");
  const [expandedCards, setExpandedCards] = useState({});
  const [showNominationModal, setShowNominationModal] = useState(false);
  const [nominationRating, setNominationRating] = useState(0);
  const [nominationComment, setNominationComment] = useState("");
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [showModal, setShowModal] = useState({
    show: false,
    type: "",
    title: "",
    message: "",
    person: "",
  });

  const clearAllFilters = () => {
    removeCountFromUrl();
    setSearchTerm("");
    setFilterTeam("All");
    setFilterSeniority("All");
    setFilterReadiness([]);
    setSortBy("Leadership Score");
    setShowSearchBar(false);
    setShowFiltersPanel(false);
    setCurrentPage(1);
  };

  const navigator = useNavigate();

  // const [activeLeadershipTab, setActiveLeadershipTab] = useState("current")

  const [currentPage, setCurrentPage] = useState(1);
  // const [currentPageCurrent, setCurrentPageCurrent] = useState(1)
  // const [currentPagePast, setCurrentPagePast] = useState(1)

  // const teams = ["All", "Engineering", "Marketing", "Sales", "Product"];
  // const seniorities = [
  //   "All",
  //   "Junior",
  //   "Mid Level",
  //   "Senior",
  //   "Lead",
  //   "Manager",
  //   "Director",
  // ];

  const seniorities = [
    { value: "All", label: t("common.all") },
    {
      value: "Junior",
      label: t("leadershipPage.filters.seniorityOptions.junior"),
    },
    {
      value: "Mid Level",
      label: t("leadershipPage.filters.seniorityOptions.midLevel"),
    },
    {
      value: "Senior",
      label: t("leadershipPage.filters.seniorityOptions.senior"),
    },
    { value: "Lead", label: t("leadershipPage.filters.seniorityOptions.lead") },
    {
      value: "Manager",
      label: t("leadershipPage.filters.seniorityOptions.manager"),
    },
    {
      value: "Director",
      label: t("leadershipPage.filters.seniorityOptions.director"),
    },
  ];
  const readinessOptions = [
    { value: "All", label: t("common.all") },
    {
      value: "Promotion-ready",
      label: t("leadershipPage.filters.readinessOptions.promotionReady"),
    },
    {
      value: "Leadership-ready",
      label: t("leadershipPage.filters.readinessOptions.leadershipReady"),
    },
    {
      value: "Near-ready",
      label: t("leadershipPage.filters.readinessOptions.nearReady"),
    },
    {
      value: "Not-ready",
      label: t("leadershipPage.filters.readinessOptions.notReady"),
    },
  ];
  // const readinessOptions = [
  //   "All",
  //   "Promotion-ready",
  //   "Leadership-ready",
  //   "Near-ready",
  //   "Not-ready",
  // ];
  // const READINESS_OPTION_OBJS = readinessOptions.map((key) => ({
  //   cat: "Group 1",
  //   key,
  // }));
  // const toOptionObj = (key) => READINESS_OPTION_OBJS.find((o) => o.key === key);
  const handleSelect = (selectedList, selectedItem) => {
    removeCountFromUrl();

    if (selectedItem === "All") {
      setFilterReadiness(["All"]);
      return;
    }
    const keys = selectedList.filter((k) => k !== "All");
    setFilterReadiness(keys);
  };

  const handleRemove = (selectedList, removedItem) => {
    removeCountFromUrl();

    if (selectedList.length === 0) {
      setFilterReadiness(["All"]);
      return;
    }
    if (selectedList.includes("All") && selectedList.length > 1) {
      setFilterReadiness(["All"]);
      return;
    }
    setFilterReadiness(selectedList);
  };
  const sortOptions = [
    {
      value: "Leadership Score",
      label: t("leadershipPage.filters.leadership"),
    },
    { value: "Name", label: t("common.name") },
  ];

  const toggleCardExpansion = (cardId) => {
    setExpandedCards((prev) => ({
      ...prev,
      [cardId]: !prev[cardId],
    }));
  };

  const sortData = (data) => {
    return [...data].sort((a, b) => {
      switch (sortBy) {
        case "score":
          return b.leadershipScore - a.leadershipScore;
        case "readiness":
          return b.readiness - a.readiness;
        case "name":
          return a.name.localeCompare(b.name);
        case "team":
          return a.team.localeCompare(b.team);
        default:
          return 0;
      }
    });
  };

  const [showSubscriptionExpired, setShowSubscriptionExpired] = useState(false);
  const [subscriptionMessage, setSubscriptionMessage] = useState("");

  const handleSubscriptionRedirect = () =>
    new Promise((resolve) => {
      setTimeout(() => {
        navigate("/pricing");
        resolve();
      }, 100);
    });

  const handleApiError = (error, options) => {
    if (error?.response?.status === 403) {
      setSubscriptionMessage(
        error?.response?.data?.message || t("subscription.upgradePlanMessage"),
      );
      setShowSubscriptionExpired(true);
      return;
    }
    return baseHandleApiError(error, options);
  };

  const submitNomination = async () => {
    console.log(
      nominationRating,
      nominationComment,
      selectedCandidate.leadershipPotentialId,
    );
    if (nominationRating === 0) {
      // alert("Please provide a rating before submitting the nomination.");
      return;
    }

    try {
      const response = await createLeadershipNominationApi({
        leadershipPotentialId: selectedCandidate.leadershipPotentialId,
        rating: nominationRating,
        comments: nominationComment,

        userId: selectedCandidate._id,
      });
      if (response.code == 201) {
        getLeadershipPotentialsApiHandler();
      }
      if (response.code == 201) {
        setShowModal({
          show: true,
          showButton: false,
          type: "success",
          title: t("leadershipPage.nominationModal.successTitle"),
          message: t("leadershipPage.nominationModal.successMessage", {
            name: selectedCandidate.name,
          }),
        });
      }
    } catch (error) {
      handleApiError(error, {
        showModal: true,
        showButton: false,
        type: "error",
        title: t("leadershipPage.nominationModal.failedTitle"),
        message: t("leadershipPage.nominationModal.failedMessage"),
      });
    }

    setShowNominationModal(false);
    setSelectedCandidate(null);
    setNominationRating(0);
    setNominationComment("");
  };

  const filteredData = [];
  // const filteredData = leadershipData.filter((person) => {
  //   // const matchesSearch =
  //   //   person.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //   //   person.team.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //   //   person.potentialRole.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //   //   person.strengths.some((strength) =>
  //   //     strength.toLowerCase().includes(searchTerm.toLowerCase())
  //   //   );
  //   // const teamMatch = filterTeam === "All" || person.team === filterTeam;
  //   // const seniorityMatch =
  //   //   filterSeniority === "All" || person.seniority === filterSeniority;
  //   // return matchesSearch && teamMatch && seniorityMatch;
  // })

  const sortedData = sortData(filteredData);

  const getScoreColor = (score) => {
    if (score >= 9) return "score-excellent";
    if (score >= 8) return "score-good";
    return "score-average";
  };

  const getReadinessColor = (readiness) => {
    if (readiness >= 90) return "readiness-high";
    if (readiness >= 80) return "readiness-medium";
    return "readiness-low";
  };

  const getReadinessBucket = (score) => {
    if (typeof score !== "number") return "Not-ready";
    if (score >= 90) return "Promotion-ready";
    if (score >= 80) return "Leadership-ready";
    if (score >= 65) return "Near-ready";
    return "Not-ready";
  };

  const LeadershipreadinessTooltip = (option) => {
    if (option === "Promotion-ready")
      return t("leadershipPage.tooltips.filterTooltip.promotionReady");
    if (option === "Leadership-ready")
      return t("leadershipPage.tooltips.filterTooltip.leadershipReady");
    if (option === "Near-ready")
      return t("leadershipPage.tooltips.filterTooltip.nearReady");
    if (option === "Not-ready")
      return t("leadershipPage.tooltips.filterTooltip.notReady");
    return "";
  };

  const handleNominate = (person) => {
    const leadershipScore = Number(person.leadershipPotentialScore);

    const leadershipPotentialUnavailable =
      !Number.isFinite(leadershipScore) ||
      leadershipScore <= 0 ||
      !person.leadershipPotentialId;

    if (leadershipPotentialUnavailable) {
      setShowModal({
        show: true,
        showButton: false,
        type: "error",
        title: "Unable to nominate",
        message: "Leadership potential is not available for this profile.",
        person: "",
      });
      return;
    }

    setSelectedCandidate(person);
    setNominationRating(0);
    setNominationComment("");
    setShowNominationModal(true);
  };
  const [teamsData, setTeamsData] = useState([]);

  const [candidate, setCandidate] = useState([]);
  const [peopleLength, setPeopleLength] = useState(null);

  // const currentPage = activeLeadershipTab === "current" ? currentPageCurrent : currentPagePast
  // const setCurrentPage = activeLeadershipTab === "current" ? setCurrentPageCurrent : setCurrentPagePast

  // const [itemsPerPage] = useState(20); // 20 items per page // Pagination
  const [itemsPerPage, setItemsPerPage] = useState(20); // Pagination

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const totalPages = Math.ceil(peopleLength / itemsPerPage);

  // Smart search & filter toggles (same as Employees)
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showFiltersPanel, setShowFiltersPanel] = useState(false);

  const start = (peopleLength ?? 0) === 0 ? 0 : indexOfFirstItem + 1;
  const end =
    (peopleLength ?? 0) === 0
      ? 0
      : Math.min(indexOfFirstItem + candidate.length, peopleLength);

  useEffect(() => {
    getLeadershipPotentialsApiHandler();
  }, [
    currentPage,
    searchTerm,
    filterTeam,
    filterSeniority,
    filterReadiness,
    sortBy,
    itemsPerPage,
  ]);

  const getAppliedFiltersCount = () => {
    let count = 0;
    if (searchTerm) count++;
    if (filterTeam && filterTeam !== "All") count++;
    if (filterSeniority && filterSeniority !== "All") count++;
    if (
      filterReadiness &&
      filterReadiness.length > 0 &&
      !filterReadiness.includes("All")
    )
      count++;
    if (sortBy && sortBy !== "Leadership Score") count++;
    return count;
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);

    console.log("Fetching data for page:", currentPage);
  };

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const getLeadershipPotentialsApiHandler = async () => {
    try {
      setLoading(true);
      const obj = {
        pageNo: currentPage,
        pageSize: itemsPerPage,
        searchFilter: searchTerm, //Optional
        level: filterSeniority, //Optional
        sortBy: sortBy, //Optional
        // type: filterReadiness === "All" ? undefined : filterReadiness,
        type: filterReadiness,
        userId: paramUserIds.length ? paramUserIds.map((id) => id) : [],
      };
      const response = await getLeadershipPotentialsApi(obj);
      setCandidate(response.data);
      setPeopleLength(response.totalCount || null);
      console.log("Leadership potentials data:", response);
    } catch (error) {
      handleApiError(error, {
        showModal: false, // keep it silent; subscription modal will show on 403
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRedirectProfile = (userId) => () => {
    console.log("userId:", userId);
    navigate(`/employees/${userId._id}`);
  };

  const displayedCandidates = candidate;
  // const displayedCandidates = candidate.filter((person) => {
  //   if (activeLeadershipTab === "current") {
  //     return person.isNominated === false
  //   } else if (activeLeadershipTab === "past") {
  //     return person.isNominated === true
  //   }
  //   return true
  // })

  const handleSearchButtonClick = () => {
    setCurrentPage(1);
    setSearchTerm(searchInputValue.trim());
    setShowSearchBar(false);
  };

  const handleClearSearch = () => {
    setSearchInputValue("");
    setSearchTerm("");
    setCurrentPage(1);
  };

  const sanitizeSearch = (val) =>
    // allow letters, numbers, space, dash, underscore, and dot; strip everything else (incl. backslash)
    val.replace(/[\\`~!@#$%^&*()+={}[\]|:;"'<>,.?/]/g, "");
  const SkeletonCard = () => (
    <div className="leadership-card" data-skeleton aria-hidden="true">
      <div className="card-main">
        <div className="card-header">
          <div className="person-info">
            <div className="person-avatar skeleton skeleton--animated sk-avatar" />
            <div className="person-details" style={{ width: "100%" }}>
              <div
                className="skeleton skeleton--animated sk-line-lg"
                style={{ marginBottom: 8 }}
              />
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div className="skeleton skeleton--animated sk-line-sm" />
                <div className="skeleton skeleton--animated sk-dot" />
                <div className="skeleton skeleton--animated sk-line-sm" />
              </div>
            </div>
          </div>
        </div>

        <div className="potential-role-compact">
          <div className="skeleton skeleton--animated sk-badge" />
        </div>

        <div className="readiness-compact" style={{ minHeight: 90 }}>
          <div className="skeleton skeleton--animated sk-progress" />
        </div>

        <div className="card-actions">
          <div className="skeleton skeleton--animated sk-btn sk-flex-1" />
          <div className="skeleton skeleton--animated sk-btn sk-btn--md" />
        </div>
      </div>
    </div>
  );

  return (
    <div className="leadership-page">
      <main className="leadership-main">
        <div className="container">
          <div className="page-top-action-row leadership-top-action-row">
            <BackButton />

            <button
              className="btn quick-link-btn page-top-cta"
              onClick={() => navigate("/talent-development/nominations")}
            >
              <ExternalLink size={14} />
              {t("leadershipPage.viewAllNominations")}
            </button>
          </div>

          <div className="page-header" style={{ marginBottom: "0px" }}>
            <div className="header-icon">
              <Users size={32} />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <h1>{t("leadershipPage.pageTitle")}</h1>
              <span className="leadership-title-info-wrap">
                <button
                  type="button"
                  className="leadership-title-info-btn"
                  aria-label={t("leadershipPage.tooltips.readiness.title")}
                >
                  <Info size={18} />
                </button>

                <span className="leadership-title-info-popover" role="tooltip">
                  <strong>{t("leadershipPage.tooltips.readiness.title")}</strong>
                  <span>{t("leadershipPage.tooltips.readiness.message")}</span>
                </span>
              </span>
            </div>
            <p>{t("leadershipPage.pageDescription")}</p>
          </div>

          {/* Smart Search & Filter panel (same as Upskill) */}
          <div className="smart-filter-panel-leadership">
            <div className="smart-filter-top-bar">
              {/* Left side (filters applied) */}
              <div className="smart-filter-left">
                <div className="smart-filter-info">
                  {getAppliedFiltersCount() > 0 && (
                    <>
                      <span className="smart-filter-badge">
                        {getAppliedFiltersCount()}
                      </span>
                      <span>{t("common.filtersApplied")}</span>
                    </>
                  )}
                </div>
              </div>

              {/* Right side (search input + icons pinned right always) */}
              <div className="smart-filter-right">
                {showSearchBar && (
                  <div className="smart-search-inline-row smart-search-right">
                    <input
                      type="text"
                      placeholder={t("leadershipPage.searchPlaceholder")}
                      value={searchInputValue}
                      onChange={(e) =>
                        setSearchInputValue(sanitizeSearch(e.target.value))
                      }
                      className="smart-search-inline-input"
                      autoFocus
                    />
                    <span className="mobile-search-placeholder-hint">
                      {t("leadershipPage.searchPlaceholder")}
                    </span>

                    {/* close search */}
                    <button
                      className="smart-filter-icon-btn active"
                      title={t("common.search")}
                      onClick={handleSearchButtonClick}
                    >
                      <Search size={18} />
                    </button>

                    {searchTerm && (
                      <button
                        className="smart-search-clear"
                        onClick={handleClearSearch}
                        title={t("common.clear")}
                      >
                        <X size={18} />
                      </button>
                    )}
                  </div>
                )}

                {/* Icons pinned to the right */}
                <div className="smart-filter-icons-right">
                  {!showSearchBar && (
                    <button
                      className={`smart-filter-icon-btn ${showSearchBar ? "active" : ""}`}
                      onClick={() => {
                        setSearchInputValue(searchTerm);
                        setShowSearchBar(true);
                        setShowFiltersPanel(false);
                      }}
                      title={t("common.search")}
                    >
                      <Search size={18} />
                    </button>
                  )}

                  <div className="smart-filter-separator" />

                  <button
                    className={`smart-filter-icon-btn ${showFiltersPanel ? "active" : ""}`}
                    onClick={() => {
                      setShowFiltersPanel(!showFiltersPanel);
                      if (!showFiltersPanel) setShowSearchBar(false);
                    }}
                    title={t("common.filters")}
                  >
                    <Filter size={18} />
                  </button>
                </div>
              </div>
            </div>

            {showFiltersPanel && (
              <>
                <div className="smart-filter-divider" />
                <div className="smart-filter-content">
                  <div className="smart-filter-grid">
                    <div className="smart-filter-item">
                      <label>{t("leadershipPage.filters.seniority")}</label>
                      <select
                        value={filterSeniority}
                        onChange={(e) => {
                          removeCountFromUrl();
                          setFilterSeniority(e.target.value);
                        }}
                        className={`smart-filter-select ${filterSeniority !== "All" ? "smart-active" : ""}`}
                      >
                        {seniorities.map((seniority) => (
                          <option key={seniority.value} value={seniority.value}>
                            {seniority.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="smart-filter-item">
                      <label>{t("leadershipPage.filters.sortBy")}</label>
                      <select
                        value={sortBy}
                        onChange={(e) => {
                          removeCountFromUrl();
                          setSortBy(e.target.value);
                        }}
                        className={`smart-filter-select ${sortBy !== "Leadership Score" ? "smart-active" : ""}`}
                      >
                        {sortOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="smart-filter-item">
                      <label>{t("leadershipPage.filters.readiness")}:</label>
                      <CustomReadinessFilter
                        options={readinessOptions}
                        selectedValues={
                          filterReadiness.length ? filterReadiness : ["All"]
                        }
                        onSelect={handleSelect}
                        onRemove={handleRemove}
                        label={t("leadershipPage.filters.readiness")}
                        getTooltip={LeadershipreadinessTooltip}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* show the count of promoted candidates */}

          {/* {countHome > 0 && ( */}
          {hasCountInUrl &&
            countHome > 0 &&
            !loading &&
            countHome - (peopleLength || 0) > 0 && (
              <div className="leadership-pipeline-banner" role="status">
                <div className="leadership-pipeline-banner__content">
                  <span className="leadership-pipeline-banner__eyebrow">
                    {t("leadershipPage.pipelineBanner.eyebrow")}
                  </span>
                  <p className="leadership-pipeline-banner__title">
                    {/* Your top-tier talent is already moving through nominations. */}
                    {t("leadershipPage.pipelineBanner.title")}
                  </p>
                  {/* <p className="leadership-pipeline-banner__summary">
                    <strong>{countHome - (peopleLength || 0)}</strong> of{" "}
                    <strong>{countHome}</strong> promotion-ready candidates are
                    already nominated.
                  </p> */}

                  <p className="leadership-pipeline-banner__summary">
                    <strong>{countHome - (peopleLength || 0)}</strong>{" "}
                    {t("leadershipPage.pipelineBanner.of")}{" "}
                    <strong>{countHome}</strong>{" "}
                    {t(
                      "leadershipPage.pipelineBanner.promotionReadyAlreadyNominated",
                    )}
                  </p>
                </div>
                <button
                  type="button"
                  className="leadership-pipeline-banner__action"
                  onClick={() => navigate(getNominationsNavigationPath())}
                >
                  {t("leadershipPage.pipelineBanner.viewNominations")}
                  <ExternalLink size={14} />
                </button>
              </div>
            )}

          {/* <div className="leadership-tabs-container">
            <div className="leadership-tabs-nav">
              <button
                className={`leadership-tab-btn ${activeLeadershipTab === "current" ? "leadership-tab-active" : ""}`}
                onClick={() => setActiveLeadershipTab("current")}
              >
                Current Nominations
              </button>
              <button
                className={`leadership-tab-btn ${activeLeadershipTab === "past" ? "leadership-tab-active" : ""}`}
                onClick={() => setActiveLeadershipTab("past")}
              >
                Past Nominations
              </button>
            </div>
          </div> */}

          {loading ? (
            <div
              className="leadership-grid is-loading"
              aria-busy="true"
              aria-live="polite"
            >
              {Array.from({ length: Math.min(6, itemsPerPage) }).map((_, i) => (
                <SkeletonCard key={`s-${i}`} />
              ))}
            </div>
          ) : displayedCandidates.length ? (
            <div className="leadership-grid">
              {displayedCandidates?.map((person) => (
                <div key={person.userId} className="leadership-card">
                  <div className="card-main">
                    <div className="card-header">
                      <div
                        className="person-info"
                        // onClick={handleRedirectProfile(person.userId)}
                        onClick={handleRedirectProfile(person)}
                      >
                        <div className="person-avatar">
                          <Users size={18} />
                        </div>
                        <div className="person-details">
                          <h3>{person.name}</h3>
                          <div className="person-meta">
                            <span className="team">{person.department}</span>
                            <span className="separator">•</span>
                            <span className="seniority">
                              {person.level
                                ? person.level
                                : t("common.notAvailable")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="potential-role-compact">
                      <Target size={14} />
                      <span>{person.designation}</span>
                    </div>

                    <div className="readiness-compact">
                      <div className="semicircle-progress">
                        <div className="semicircle-container">
                          <CircularProgressbar
                            value={person.leadershipPotentialScore / 2}
                            maxValue={100}
                            text={""}
                            styles={buildStyles({
                              pathColor: "#672024",
                              trailColor: "#e0e0e0",
                              strokeLinecap: "butt",
                              rotation: 0.75,
                            })}
                          />
                        </div>
                        <div className="leadership-score-value">
                          {person.leadershipPotentialScore}%
                        </div>
                        <div className="readiness-info-below">
                          <TrendingUp size={14} />
                          <span>{t("leadershipPage.readiness")}</span>
                          {/*<span
                            className={`readiness-percentage ${getReadinessColor(
                              person.leadershipPotentialScore
                            )}`}
                          >
                            {person.leadershipPotentialScore}%
                          </span>*/}
                        </div>
                      </div>
                    </div>

                    <div className="card-actions">
                      <button
                        className="expand-btn"
                        onClick={() => toggleCardExpansion(person.userId)}
                      >
                        <span>{t("leadershipPage.details")}</span>
                        {expandedCards[person.userId] ? (
                          <ChevronUp size={16} />
                        ) : (
                          <ChevronDown size={16} />
                        )}
                      </button>
                      {/* {activeLeadershipTab === "current" && (
                        <button className="btn btn-primary nominate-btn-compact" onClick={() => handleNominate(person)}>
                        {t("leadershipPage.nominate")}
                      </button>
                      )} */}

                      {/* Show nominate button for all cards */}
                      <button
                        disabled={!leadershipAccess.canSaveLeadershipPotential}
                        className="btn btn-primary nominate-btn-compact"
                        onClick={() => handleNominate(person)}
                      >
                        {t("leadershipPage.nominate")}
                      </button>
                    </div>
                  </div>

                  {expandedCards[person.userId] && (
                    <div className="card-expanded">
                      <div className="expanded-section">
                        <h4>
                          <Brain size={16} />
                          {t("leadershipPage.leadershipStrengths")}
                        </h4>
                        <div className="strengths-tags">
                          {person.leadershipStrengths.length === 0 ? (
                            <span
                              className="no-strengths"
                              style={{ fontSize: "12px" }}
                            >
                              {t("leadershipPage.noStrengths")}
                            </span>
                          ) : (
                            person.leadershipStrengths.map(
                              (strength, index) => (
                                <span key={index} className="strength-tag">
                                  {strength}
                                </span>
                              ),
                            )
                          )}
                        </div>
                      </div>

                      <div className="expanded-section">
                        <h4>
                          <Award size={16} />
                          {t("leadershipPage.keyAchievements")}
                        </h4>
                        <ul className="achievements-list">
                          {person.keyAchievements.length === 0 &&
                          !person.isResumeUploaded ? (
                            <li className="no-achievements">
                              {t("leadershipPage.resumeNotUploaded")}
                            </li>
                          ) : person.keyAchievements.length === 0 &&
                            person.isResumeUploaded ? (
                            <li className="no-achievements">
                              {t("leadershipPage.noAchievements")}
                            </li>
                          ) : (
                            person.keyAchievements.map((achievement, index) => (
                              <li key={index}>{achievement}</li>
                            ))
                          )}
                        </ul>
                      </div>

                      <div className="expanded-section">
                        <h4>
                          <MessageSquare size={16} />
                          {t("leadershipPage.developmentAreas")}
                        </h4>
                        <ul className="risk-list">
                          {person.developmentAreas.length === 0 ? (
                            <li>{t("leadershipPage.noDevelopmentAreas")}</li>
                          ) : (
                            person.developmentAreas.map((risk, index) => (
                              <li key={index}>{risk}</li>
                            ))
                          )}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : getAppliedFiltersCount() > 0 ? (
            hasCountInUrl ? null : (
              <FilterNoResults
                title={t("common.noResults")}
                message={t("common.adjustOrClear")}
                clearLabel={t("common.clearFilters")}
                onClear={clearAllFilters}
              />
            )
          ) : (
            <EmptyState
              icon={TrendingUp}
              iconSize={48}
              title={t("leadershipPage.emptyTitle")}
              message={t("leadershipPage.emptyMessage")}
              actionLabel={t("common.goToEmployees")}
              onAction={() => navigate("/employees")}
            />
          )}

          {/* )} */}

          {/* Pagination */}

          {!loading && peopleLength && (
            <Pagination
              loading={loading}
              total={peopleLength || 0}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              currentPageCount={candidate.length}
              onPageChange={(page) => setCurrentPage(page)}
              pageSizeOptions={[20, 40, 60, 100]}
              onPageSizeChange={(size) => {
                setItemsPerPage(size);
                const newTotalPages = Math.max(
                  1,
                  Math.ceil((peopleLength || 0) / size),
                );
                if (currentPage > newTotalPages) setCurrentPage(newTotalPages);
              }}
              infoRenderer={({ start, end, total }) =>
                t("mobilityPage.paginationInfo", { start, end, total })
              }
            />
          )}
        </div>
      </main>

      {/* Nomination Modal */}
      {showNominationModal && selectedCandidate && (
        <Modal
          show={showNominationModal}
          onClose={() => setShowNominationModal(false)}
          type="info"
          title={t("leadershipPage.nominationModal.title")}
          showButton={false}
        >
          <div className="leadership-nomination-modal-content">
            <div className="leadership-nominee-info">
              <div className="leadership-nominee-avatar">
                <User size={32} />
              </div>
              <div className="leadership-nominee-details">
                <h4>{selectedCandidate.name}</h4>
                <p>
                  {selectedCandidate.department
                    ? selectedCandidate.department
                    : t("common.notAvailable")}{" "}
                  •{" "}
                  {selectedCandidate.level
                    ? selectedCandidate.level
                    : t("common.notAvailable")}
                </p>
              </div>
            </div>

            <div className="leadership-rating-section">
              <label className="leadership-rating-label">
                {t("leadershipPage.nominationModal.rateCandidate")}
              </label>
              <div className="leadership-star-rating">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((star) => (
                  <button
                    key={star}
                    className={`leadership-star ${star <= nominationRating ? "filled" : ""}`}
                    onClick={() => setNominationRating(star)}
                  >
                    <Star size={24} />
                  </button>
                ))}
              </div>
              <div className="leadership-rating-display">
                {nominationRating > 0 && (
                  <span className="leadership-rating-text">
                    {t("leadershipPage.nominationModal.starsSelected", {
                      rating: nominationRating,
                    })}
                  </span>
                )}
              </div>
            </div>

            <div className="leadership-comment-section">
              <label
                htmlFor="nomination-comment"
                className="leadership-comment-label"
              >
                {t("leadershipPage.nominationModal.additionalComments")}
              </label>
              <textarea
                id="nomination-comment"
                value={nominationComment}
                onChange={(e) => setNominationComment(e.target.value)}
                placeholder={t(
                  "leadershipPage.nominationModal.commentsPlaceholder",
                )}
                className="leadership-comment-textarea"
                rows={4}
              />
            </div>

            <div className="leadership-modal-actions">
              <button
                className="leadership-modal-btn leadership-secondary"
                onClick={() => setShowNominationModal(false)}
              >
                {t("leadershipPage.nominationModal.cancel")}
              </button>
              <button
                className="leadership-modal-btn leadership-primary"
                onClick={submitNomination}
                disabled={nominationRating === 0}
              >
                {t("leadershipPage.nominationModal.submitNomination")}
              </button>
            </div>
          </div>
        </Modal>
      )}

      <Modal
        show={showModal.show}
        showButton={showModal.showButton}
        onClose={() =>
          setShowModal({
            show: false,
            type: "",
            title: "",
            message: "",
            person: "",
          })
        }
        type={showModal.type}
        title={showModal.title}
        message={showModal.message}
      />

      <SubscriptionExpiredModal
        show={showSubscriptionExpired}
        message={subscriptionMessage}
        onRedirect={handleSubscriptionRedirect}
      />
    </div>
  );
};

export default LeadershipPage;
